/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'

import { IProgram } from '../../interfaces'
import { MarkerCard } from '..'
import GoogleMapReact, { Coords } from 'google-map-react'

export interface IMap {
  className?: string
  programs: IProgram[]
}

const Marker = function ({ program }: { program: IProgram }) {
  const [showTooltip, setShowTooltip] = React.useState(false)

  const markerRef = React.useRef<any>(null)

  const handleClickOutside = (event: any) => {
    if (markerRef.current && !markerRef.current.contains(event.target)) {
      setShowTooltip(false)
    }
  }

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <div ref={markerRef} className='ocla-pin' onClick={() => setShowTooltip(!showTooltip)}>
        {showTooltip && <MarkerCard program={program} />}
      </div>
    </>
  )
}

const defaultCoords: Coords = {
  lat: 34.052235,
  lng: -118.243683,
}

const Map = function (props: any) {
  const { programs } = props

  return (
    <div className='ocla-map'>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string }}
        defaultCenter={defaultCoords}
        defaultZoom={10}
      >
        {programs.map((program: IProgram) => (
          <Marker
            key={programs.id}
            // @ts-ignore
            lat={program.latitude}
            lng={program.longitude}
            program={program}
          />
        ))}
      </GoogleMapReact>
    </div>
  )
}

export default React.memo(Map)
